import React from 'react';
import logoSrc from '../../assets/streamQuestOnlyLogo.png';

export default function PageShell({ className, children }) {
  return (
    <div className={`page-shell${className ? ` ${className}` : ''}`}>
      <img src={logoSrc} alt="" className="page-shell-logo" />
      {children}
    </div>
  );
}
